import { PostAPI } from 'Components/Helper/Helpers';

export const SelectURL = async (request) => {
    return PostAPI(request, 'CASADMT/UserOnbording');
};

export const DeleteBeneficiary = async (request) => {
    return PostAPI(request, 'CASADMT/DeleteBeneficiary');
};
export const Select = async (request) => {
    return PostAPI(request, 'CASADMT/Select');
};

export const VerifyBeneficiary = async (request) => {
    return PostAPI(request, 'CASADMT/GenerateBeneficiarOTP');
};

export const AddBeneficiary = async (request) => {
    return PostAPI(request, 'CASADMT/AddBeneficiary');
};

export const ViewBeneficiary = async (request) => {
    return PostAPI(request, 'CASADMT/ViewBeneficiary');
};

export const MoneyTransfer = async (request) => {
    return PostAPI(request, 'CASADMT/MoneyTransfer');
};

export const SelectBank = async (request) => {
    return PostAPI(request, 'CASADMT/SelectBank');
};
export const SelectBankList = async (request) => {
    return PostAPI(request, 'CASADMT/Select');
};
  
export const GenerateOTPForMoneyTransfer = async (request) => {
    return PostAPI(request, 'CASADMT/GenerateOTPForMoneyTransfer');
};

export const GetSplitAmountForTransaction = async (request) => {
    return PostAPI(request, 'CASADMT/GetSplitAmountForTransaction');
};

export const GenerateOTPForSplitAmount = async (request) => {
    return PostAPI(request, 'CASADMT/GenerateOTPForSplitAmount');
};

export const MerchantActivation = async (request) => {
    return PostAPI(request, 'CASADMT/MerchantActivation');
};
